import {Form, Input, Switch} from 'antd';

const StateForm = ({form, onFinish}) => {
    return (
        <Form
            form={form}
            name="StateForm"
            labelCol={{span: 8}}
            wrapperCol={{span: 16}}
            layout="horizontal"
            onFinish={onFinish}
        >
            <Form.Item label="Bundesland" name="name">
                <Input/>
            </Form.Item>
            <Form.Item label="Ist aktiv" valuePropName="checked" name="is_visible" initialValue={true}>
                <Switch/>
            </Form.Item>
        </Form>
    );
};

export default StateForm;
